module.exports = __webpack_public_path__ + "static/img/nospecialevent.e0d9ca7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nospecialevent.png
// module id = xZ2G
// module chunks = 5